import { AppEnv } from '../config';

export const CommunityEndpoint = AppEnv.API_ENDPOINT;
